import { combineReducers } from 'redux';
import {
  SEARCHING,
  SEARCH_COMPLETE,
  POLLING,
  INPUT_CHANGE,
  LEAD_CREATED,
  UPDATE_ACTIVE_TAB,
  POLL_ERROR,
  REPORT_LOADED,
  LOADING,
  LOADING_COMPLETE,
  STAFF_CHECK,
  POLL_TIMEOUT,
  SEARCH_PARAM,
  DECRYPT_CUSTOMER_DATA
} from './constants';
import update from 'immutability-helper';

const initialState = {
  usFoods: window.us_foods,
  step: 0,
  grade: {},
  funnelType: '',
  website: {
    domain: '',
    id: '',
    ref: '',
  },
  user: {
    name: '',
    email: '',
    phone: '',
    zipcode: '',
    restaurantName: '',
    usfMarketName: '',
    usfEmployeeName: '',
    usfEmployeeEmail: '',
    usfCustomerId: '',
    userType: '',
    datetime: '',
    unlocked: false,
    leadSlug: '',
    isStaff: false,
  },
  poll: {
    count: 0,
    complete: false,
    error: '',
    timeout: false,
  },
  loading: false,
  search_params: {
    utm_source: '',
    utm_content: '',
    lead_source: ''
  }
};

const appReducer = (state = initialState, action) => {
  switch (action.type) {
    case SEARCH_PARAM: {
      return update(state, {
        search_params: {
          [action.param]: { $set: action.value },
        },
      });
    }
    case STAFF_CHECK: {
      return update(state, {
        user: {
          isStaff: { $set: action.isStaff },
        },
      });
    }
    case INPUT_CHANGE: {
      const { model, field, value } = action;
      return update(state, {
        [model]: {
          [field]: { $set: value },
        },
      });
    }
    case POLLING: {
      const incremented = state.poll.count + 1;
      return update(state, {
        poll: {
          count: { $set: incremented },
        },
      });
    }
    case POLL_ERROR: {
      return update(state, {
        poll: {
          error: {
            $set:
              'There was an error with the site you requested.  Please try again later.',
          },
        },
      });
    }
    case SEARCHING: {
      const { domain, id, ref } = action;
      return update(state, {
        website: {
          domain: { $set: domain },
          id: { $set: id },
          ref: { $set: ref },
        },
        step: { $set: 1 },
        loading: { $set: false },
      });
    }
    case POLL_TIMEOUT: {
      return update(state, {
        poll: {
          timeout: { $set: true },
        },
        step: { $set: 2 },
      });
    }
    case SEARCH_COMPLETE: {
      return update(state, {
        grade: { $set: action.data },
        step: { $set: 2 },
        poll: {
          complete: { $set: true },
        },
      });
    }
    case LEAD_CREATED: {
      return update(state, {
        user: {
          leadSlug: { $set: action.leadSlug },
          unlocked: { $set: true },
        },
        funnelType: { $set: action.funnelType },
        loading: { $set: false },
        step: { $set: 3 },
      });
    }
    case REPORT_LOADED: {
      const { report } = action;
      const { is_bentobox: isBentobox } = report;
      return update(state, {
        grade: { $set: report },
        user: {
          unlocked: { $set: !isBentobox },
        },
        step: { $set: isBentobox ? 2 : 3 },
        loading: { $set: false },
      });
    }
    case LOADING: {
      return update(state, {
        loading: { $set: action.entity },
      });
    }
    case LOADING_COMPLETE: {
      return update(state, {
        loading: { $set: false },
      });
    }
    case DECRYPT_CUSTOMER_DATA: {
      const { data } = action;
      return update(state, {
        user: {
          name: { $set: data.contactname || '' },
          email: { $set: data.contactemail || '' },
          phone: { $set: data.contactphone || '' },
          zipcode: { $set: data.zipcode || '' },
          restaurantName: { $set: data.businessname || '' },
          usfMarketName: { $set: data.marketname || '' },
          usfCustomerId: { $set: data.customernumber || '' },
          userType: { $set: data.usertype || '' },
          datetime: { $set: data.datetime || '' }
        }
      });
    }
    default:
      return state;
  }
};

export default appReducer;
